import { Component, OnInit } from '@angular/core';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';

@Component({
    selector: 'redirect-silent-renew',
    templateUrl: './redirect-silent-renew.component.html',
    styleUrls: ['./redirect-silent-renew.component.scss'],
    standalone: false
})
export class RedirectSilentRenewComponent implements OnInit {

  constructor(private oauthService: OAuthServiceService) {}

  ngOnInit(): void {
    this.oauthService.checkAuth().subscribe();
  }
}
